import {useState} from 'react';
import {
    Button,
    ButtonProps,
} from '@mantine/core';
import {AiOutlinePlus} from 'react-icons/ai';

import {AddFormDrawer} from '../drawers/AddFormDrawer.tsx';
import config from '../config/index.ts';

export const AddRecordButton = (props: ButtonProps) => {

    const [drawerOpened, setDrawerOpened] = useState(false);

    if (drawerOpened) {
        return (
            <AddFormDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        );
    }

    return (
        <Button
            leftSection={<AiOutlinePlus/>}
            onClick={() => {
                setDrawerOpened(true);
            }}
            {...props}
        >{`New ${config.titles.singular}`}</Button>
    );
};
